<script>
    import SmartFilterAddHeader from '@/components/page-smart-filter/smart-filter-add/SmartFilterAddHeader.vue';
    import SmartFilterDataMain from '@/components/page-smart-filter/SmartFilterDataMain.vue';
    import SmartFilterDataProviderAndGame from '@/components/page-smart-filter/SmartFilterDataProviderAndGame.vue';
    import SmartFilterDataFilter from '@/components/page-smart-filter/SmartFilterDataFilter.vue';
    import SmartFilterDataTag from '@/components/page-smart-filter/SmartFilterDataTag.vue';
    import SmartFilterDataSearch from '@/components/page-smart-filter/SmartFilterDataSearch.vue';

    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            } 
        },
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_SMART_FILTER_ADD},
            addData() {return this.$store.getters.SMART_FILTER_DATA_ADD},
        },
        components: {
            SmartFilterAddHeader: SmartFilterAddHeader,
            SmartFilterDataMain: SmartFilterDataMain,
            SmartFilterDataProviderAndGame: SmartFilterDataProviderAndGame,
            SmartFilterDataFilter: SmartFilterDataFilter,
            SmartFilterDataTag: SmartFilterDataTag,
            SmartFilterDataSearch: SmartFilterDataSearch,
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false, isSetValue = false) {
                this.errorText = await changeData(
                    event, fieldName, 'SMART_FILTER_DATA_ADD_UPDATE', 'CHECK_SMART_FILTER_ADD', isCheckBox, isSetValue
                );
            },
            async pushData(value, fieldName) {
                this.$store.commit('SMART_FILTER_DATA_ADD_PUSH',{
                    fieldName: fieldName,
                    fieldValue: value,
                });
            },
            async spliceData(value, fieldName) {
                this.$store.commit('SMART_FILTER_DATA_ADD_SPLICE',{
                    fieldName: fieldName,
                    fieldValue: value,
                });
            }
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <SmartFilterAddHeader />
        <hr class="hr_light_98">
        <div class="left_sub_panel_data mb_10">
            <label
                v-if="errorText !== ''"
                class="error_text mt_10"
            >{{ errorText }}</label>
        </div>

        <SmartFilterDataMain 
            :data="addData"
            :updateData="updateData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataProviderAndGame 
            :data="addData"
            :pushData="pushData"
            :spliceData="spliceData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataFilter 
            :data="addData"
            :pushData="pushData"
            :spliceData="spliceData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataTag 
            :data="addData"
            :updateData="updateData"
        />
        <hr class="hr_light_98">
        <SmartFilterDataSearch 
            :data="addData"
            :updateData="updateData"
        />
    </div>
</template>